import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Divider,
  Grid,
  FormControl,
  TextField,
} from "@mui/material";
import {
  Close as CloseIcon,
  InfoOutlined as InfoOutlinedIcon,
  Store as StoreIcon,
} from "@mui/icons-material";
import ModalHeader from "../ModalHeader";
import Mount from "../../component/Mount";
import useCommonContext from "../../store/CommonContext";
import { RDDeviceStatus } from "../../utils/constants";
import AnimateIcon from "../../component/AnimateIcon";
import AnimDeviceReady from "../../assets/animate-icons/device_ready.json";
import AnimDeviceScanning from "../../assets/animate-icons/fingerprint_scan.json";
import AnimDeviceSuccess from "../../assets/animate-icons/fingerprint_success.json";
import AnimDeviceFail from "../../assets/animate-icons/fingerprint_fail.json";
import AnimDeviceConnect from "../../assets/animate-icons/device_connect.json";
import { CaptureFingerPrint, CaptureFingerPrintWadh, CaptureFingerPrintWadh18, GetMFS100InfoLoad } from "../../utils/MantraCapture";
import MyButton from "../../component/MyButton";
import MachineDetectButton from "../../component/aeps/MachineDetectButton";
import RdDeviceSearch from "../../component/RdDeviceSearch";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ApiEndpoints from "../../network/ApiEndPoints";
import AuthContext from "../../store/AuthContext";


import { postJsonData } from "../../network/ApiController";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "45%",
    bgcolor: "background.paper",
    boxShadow: 24,
    fontFamily: "Poppins",
    height: "max-content",
    overflowY: "scroll",
    p: 2,
    pb: 3,
  };
  export function getColor(status) {
  if (status === "NOTREADY") {
    return "red";
  } else if (status === "READY") {
    return "green";
  } else {
    return "red";
  }
}

const MerchantOnboardingIpay = ({ open, onClose,aeps,refKey,pidWidth }) => {
    const [aadhaar, setAadhaar] = useState();
    console.log("pidWidth",pidWidth);
    
      const context = useContext(AuthContext);
       const { refreshUser } = useCommonContext();
      const userLat = context.location.lat && context.location.lat;
  const userLong = context.location.long && context.location.long;
    const [request, setRequest] = useState(false);
  
   const {
    aepsType,
    setAepsType,
    rdDevice,
    rdDeviceList,
    machineRequest,
    setRdDevice,
    setRdDeviceList,
    setMachineRequest,
    setAepsTypeInLocalAndHook,
  } = useCommonContext();
    const [scanData, setScanData] = useState();
    const [scanAnim, setScanAnim] = useState(RDDeviceStatus.READY);
  
    function resolveScanImage(status) {
    switch (status) {
      case RDDeviceStatus.NOT_READY:
        return <AnimateIcon src={AnimDeviceConnect} />;
      case RDDeviceStatus.READY:
        return <AnimateIcon src={AnimDeviceReady} />;
      case RDDeviceStatus.SCANNING:
        return <AnimateIcon src={AnimDeviceScanning} />;
      case RDDeviceStatus.SCAN_SUCCESS:
        return <AnimateIcon src={AnimDeviceSuccess} />;
      case RDDeviceStatus.SCAN_FAILED:
        return <AnimateIcon src={AnimDeviceFail} />;
      default:
        return <AnimateIcon src={AnimDeviceConnect} />;
    }
  }
    function getRdDeviceInfo() {
      setMachineRequest(true);
      // console.log("machine func call . . .");
      setTimeout(() => {
        // console.log("inside machine func timeout . . .");
        GetMFS100InfoLoad(
          setMachineRequest,
          (dataArray) => {
            setScanData();
            // setScanAnim(RDDeviceStatus.NOT_READY);
            for (let i = 0; i < dataArray.length; i++) {
              // console.log("data array=>", dataArray[i].status);
              const data = dataArray[i];
              if (data && data.status === RDDeviceStatus.READY) {
                setScanAnim(data ? data.status : RDDeviceStatus.SCAN_FAILED);
                setRdDevice(data);
              } else if (data && data.status === RDDeviceStatus.NOT_READY) {
                setScanAnim(data ? data.status : RDDeviceStatus.SCAN_FAILED);
                setRdDevice(data);
              }
            }
            if (dataArray) setRdDeviceList(dataArray);
            // console.log("success status=>", machineRequest);
          },
          (err) => {
            setScanAnim(RDDeviceStatus.NOT_READY);
            setRdDevice();
            setRdDeviceList();
            setMachineRequest(false);
            setScanData();
            // setScanAnim(err ? err.status : RDDeviceStatus.SCAN_FAILED);
            // console.log("failed status=>", machineRequest);
          },
        );
      }, 500);
      // setMachineRequest(false);
    }
      const outletAuthApiCall = () => {
        if (scanData) {
          let data = {};
          let apiEnd = ApiEndpoints.MERCHANT_BIOMETRIC_KYC_IPAY_AEPS1;
          if (aepsType)
            data = {
              AadharNumber: aadhaar && aadhaar,
              ci: scanData.cI,
              dc: scanData.dC,
              dpId: scanData.dpId,
              errInfo: scanData?.errInfo,
              fCount: scanData?.fCount,
              mc: scanData?.mC,
              mi: scanData?.mI,
              nmPoints: scanData?.nmPoints,
              pidData: scanData?.pidData,
              pidDataType: scanData?.pidDataType,
              qScore: scanData?.qScore,
              rdsId: scanData?.rdsId,
              rdsVer: scanData?.rdsVer,
              sessionKey: scanData?.sessionKey,
              srno: scanData?.srno,
              hmac: scanData?.hMac,
              sysId: scanData?.sysId,
               ts: scanData?.ts || "",
              latitude: userLat,
              longitude: userLong,
              pf: "WEB",
             referenceKey: refKey,
              type: "DAILY_LOGIN",
            };
          else if (aepsType) {
            apiEnd = ApiEndpoints.MERCHANT_BIOMETRIC_KYC_IPAY_AEPS1;
            data = {
              adhaarNumber: aadhaar && aadhaar,
              captureResponse: scanData,
              deviceId: scanData.srno,
              latitude: userLat,
              longitude: userLong,
            };
          }
          postJsonData(
            apiEnd,
            data,
            setRequest,
            (res) => {
              okSuccessToast("Success");
             refreshUser();
              onClose();
            },
            (err) => {
              const errorData = JSON.stringify(err.response.data);
              apiErrorToast(scanData.dpId ? errorData : "Provide correct fingar");
            },
          );
        } else {
          apiErrorToast("Scan first");
        }
      };
      useEffect(() => {
  if (scanData) {
    outletAuthApiCall();
  }
}, [scanData]);
  return (
     <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="sm_modal">
          <ModalHeader
            title={
          "2 Factor Authentication"
            }
            subtitle="Enjoy seamless aadhaar services with Vdeepay"
            handleClose={onClose}
          />
          <Box
            sx={{
              // mx: 2,
              objectFit: "contain",
              width: "100%",
            }}
          >
            {/* <Mount visible={true}>
              {setAepsTypeInLocalAndHook(AEPS_TYPE.AEPS1)}
            </Mount> */}

            {/* aeps 2FA login view forms and options */}
            <Mount
              visible={
                aepsType
              }
              // &&
              // twoFAStatus === TWOFASTATUS.LOGINREQUIRED
            >
              <Divider
                sx={{
                  borderTop: "2px solid #d3d3d3",
                }}
              />
              <Box
                component="form"
                id="outlet_login"
                validate
                autoComplete="off"
                className="text-center"
                // onSubmit={}
                sx={{
                  "& .MuiTextField-root": { m: 2 },
                  objectFit: "contain",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid container className="position-relative">
                  <Grid item md={12} xs={12}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        autoComplete="off"
                        label="Aadhaar Number"
                        id="aadhaarNo"
                        size="small"
                        type="number"
                        required
                        value={aadhaar}
                        onChange={(e) => setAadhaar(e.target.value)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Box sx={{ display: "flex", pl: 1, pt: 1 }}>
                      <div
                        style={{
                          width: "50%",
                          minWidth: "30%",
                          height: "auto",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        {/* red dot code */}
                        {rdDevice && (
                          <div
                            style={{
                              background: getColor(
                                rdDevice ? rdDevice.status : "",
                              ),
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                          ></div>
                        )}
                        {/* Rd service */}
                        <span style={{ marginBottom: "12px" }}>
                          {resolveScanImage(scanAnim)}
                        </span>
                        <span
                          style={{
                            position: "absolute",
                            bottom: "8px",
                            display: "flex",
                            justifyContent: "between",
                            alignItems: "center",
                          }}
                        >
                          <MyButton
                            hidden={
                              !rdDevice ||
                              rdDevice.status === RDDeviceStatus.NOT_READY
                            }
                            text="start scan"
                            mr={3}
                            onClick={() => {
                              setScanAnim(RDDeviceStatus.SCANNING);
                             CaptureFingerPrintWadh(
  rdDevice?.rdport,
  pidWidth, // yaha dynamic wadh jayega
  (msg, data) => {
    setScanAnim(RDDeviceStatus.SCAN_SUCCESS);
    setScanData(data);
  },
  (err) => {
    apiErrorToast("Error", JSON.stringify(err));
    setScanAnim(RDDeviceStatus.SCAN_FAILED);
  }
);
                            }}
                          />
                          <MachineDetectButton
                            onClick={() => {
                              if (getRdDeviceInfo) getRdDeviceInfo();
                            }}
                          />
                        </span>
                      </div>
                      <Grid container>
                        <Grid item md={12} xs={12}>
                          {
                            <RdDeviceSearch
                              list={rdDeviceList}
                              cb={(item) => {
                                if (item) setRdDevice(item);
                              }}
                              defaultValue={
                                rdDeviceList?.length > 0 &&
                                rdDeviceList[0]?.info
                              }
                            />
                          }

                          {!machineRequest && rdDeviceList === undefined && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: "red",
                                textAlign: "left",
                              }}
                            >
                              You do not have any RD Service installed in your
                              system
                            </Typography>
                          )}
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <FormControl sx={{ width: "100%" }}>
                            <TextField
                              autoComplete="off"
                              label=""
                              id="d_status"
                              size="small"
                              placeholder="Device Status"
                              value={
                                rdDevice
                                  ? rdDevice.status
                                  : RDDeviceStatus.NOT_READY
                              }
                              disabled
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <FormControl sx={{ width: "100%" }}>
                            <TextField
                              autoComplete="off"
                              label=""
                              id="scan_quality"
                              size="small"
                              placeholder="Scan Quality"
                              defaultValue={""}
                              value={scanData && scanData.score}
                              disabled
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Box>
                    {/* </Box> */}
                    <Typography sx={{ mt: 2 }}>
                      <span style={{ fontWeight: "bold", color: "#DC5F5F" }}>
                        Note:
                      </span>{" "}
                      connect scanner for scanning the impression(when scanner
                      is connected dot in the corner will be green.)
                    </Typography>
                    {/* <Button
                      onClick={() => {
                        outletAuthApiCall();
                      }}
                    >
                      submit
                    </Button> */}
                  </Grid>
                </Grid>
              </Box>
            </Mount>
            {/* <Mount visible={aepsType === AEPS_TYPE.AEPS2}>
              <Typography variant="h4">coming soon......</Typography>
            </Mount> */}
          </Box>
        </Box>
      </Modal>
  );
};

export default MerchantOnboardingIpay;
